import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageModel } from '../model/page-mode.model';
import { FiltroSetor } from '../model/setor/setor-filtro.model';
import { Setor } from '../model/setor/setor.model';
import { SetorVinculoBase } from '../model/setor/setor-vinculo-base.model';

@Injectable({
  providedIn: 'root'
})
export class SetorService {

  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/setor`;

  buscarSetores(filtroSetor: FiltroSetor, page: number, limit: number): Observable<PageModel> {
    return this.http.post<PageModel>(`${this.urlBase}/buscar-paginados`, filtroSetor, {
      params: {
        page: page,
        limit: limit
      }
    });
  }

  salvarSetor(setor: Setor): Observable<number> {
    return this.http.post<number>(this.urlBase, setor);
  }

  buscarSetoresSelect(): Observable<Setor[]> {
    return this.http.get<Setor[]>(`${this.urlBase}/select`, {
      headers: { 'no-loading': 'true' },
    });
  }

  buscarSetoresSelectAtivo(): Observable<Setor[]> {
    return this.http.get<Setor[]>(`${this.urlBase}/select/ativo`, {
      headers: { 'no-loading': 'true' },
    });
  }

  buscarBasesDoSetor(setorId: number, plataformaId?: number): Observable<SetorVinculoBase[]> {
    return this.http.get<SetorVinculoBase[]>(`${this.urlBase}/${setorId}/bases`, {
      params: plataformaId ? { plataformaId } : {},
      headers: { 'no-loading': 'true' },
    });
  }
}
